import React from "react";

import { Event } from "@nens/brostar/openapi-client";
import { ColumnDefinition } from "@nens/chakra/components";

import { TableOverview } from "@/components/table-overview";
import { renderDefault } from "@/helpers/table-render-functions";
import { useQueryPagination } from "@/hooks/use-pagination";
import { useRouterTableData } from "@/hooks/use-router-table-data";
import { DeleteGmwEventButton, addDeleteButton } from "@/libs/delete-button";
import { useGmwEventListQuery } from "@/queries/query-gmw-event";

export const gmwEventInformation: { key: keyof Event; label: string }[] = [
  { key: "eventName", label: "Gebeurtenis naam" },
  { key: "eventDate", label: "Datum" },
];

const columnDefinitions: ColumnDefinition<Event>[] = addDeleteButton(
  gmwEventInformation.map(({ key, label }, index) => ({
    title: label,
    renderFunction: (row: Event) =>
      renderDefault(row[key], index === 0 ? `/gmw/gebeurtenissen/${row.uuid}/` : undefined),
    width: "1fr",
  })),
  DeleteGmwEventButton
);

const GmwEventTable: React.FC<{ gmwBroId: string }> = ({ gmwBroId }) => {
  const { page, setPage } = useRouterTableData({ hasSearchParams: false });
  const { data: gmwEventList, isLoading } = useGmwEventListQuery({ gmwBroId, page });
  const { ...paginationProps } = useQueryPagination({ queryResponse: gmwEventList, page, setPage });

  if (gmwEventList != null) {
    gmwEventList.results.sort((a, b) => {
      // Otherwise, compare the dates
      return a.eventDate.getTime() - b.eventDate.getTime();
    });
  }

  return (
    <TableOverview
      themeColor="#b9acfc"
      isLoading={isLoading}
      tableData={gmwEventList?.results ?? []}
      columnDefinitions={columnDefinitions}
      paginationProps={paginationProps}
    />
  );
};

export { GmwEventTable };
